/**
 * @module usePhoneHeavy
 * @description
 */
import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import { CustomCohesionContext } from 'ui/providers/cohesion';
import requestMonarch from 'ui/js/helpers/monarch';
import { trackEvent } from 'ui/js/helpers/tracking';

export const usePhoneHeavy = () => {
  const router = useRouter();
  const { cohesionReady } = useContext( CustomCohesionContext );

  const [ phoneHeavy, setPhoneHeavy ] = useState( false );

  useEffect( () => {
    if ( ! cohesionReady ) return;

    if ( router?.query?.utm_stlnk === 'PhoneHeavy' || router?.query?.heavy === 'phone' ) {
      setPhoneHeavy( true );
      document.body.setAttribute( 'data-phone-heavy', 'true' );

      const data = {
        elementType: 'BUY FLOW',
        position: 'PHONE HEAVY'
      };

      trackEvent( { action: 'elementViewed', data } );
      return;
    }

    // @ts-ignore:next-line
    requestMonarch( 'rule', 'globalPhoneHeavy', {}, {}, ( result ) => {
      if ( result?.globalPhoneHeavy === true ) {
        setPhoneHeavy( true );
        document.body.setAttribute( 'data-phone-heavy', 'true' );

        const data = {
          elementType: 'BUY FLOW',
          position: 'PHONE HEAVY'
        };

        trackEvent( { action: 'elementViewed', data } );
      }
    } );
  }, [ cohesionReady, router?.query ] );

  return phoneHeavy;
};

export default usePhoneHeavy;
